export interface DownloadBlobOptions {
  data: Blob | ArrayBuffer;
  defaultFileName: string;
  contentDisposition?: string;
}

export function downloadBlob({ data, defaultFileName, contentDisposition }: DownloadBlobOptions): void {
  const blob = data instanceof Blob ? data : new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/);
    link.download = match?.[1] ?? defaultFileName;
  } else {
    link.download = defaultFileName;
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
